export class GantCoLinereqModel {
    poNumber: string;
    salesPrice: string;
    deliveryDate: any;
    exfactoryDate:any
    style:string;
    destinations: GantDestinationModel[]

    constructor(poNumber: string, salesPrice: string, deliveryDate: any,exfactoryDate:any, style:string, destinations: GantDestinationModel[]) {
        this.poNumber = poNumber
        this.salesPrice = salesPrice
        this.deliveryDate = deliveryDate
        this.exfactoryDate = exfactoryDate
        this.style = style
        this.destinations = destinations
    }
}

export class GantDestinationModel {
    name: string;
    colors: GantColorModel[]
    buyerAddressCode?:number;
    deliveryAddressCode?:number;

    constructor(name: string, colors: GantColorModel[],buyerAddressCode?:number,deliveryAddressCode?:number,) {
        this.name = name
        this.colors = colors
        this.buyerAddressCode = buyerAddressCode
        this.deliveryAddressCode = deliveryAddressCode
    }
}

export class GantColorModel {
    name: string;
    sizes: GantSizeModel[]
    salePrice?: string
    constructor(name: string, sizes: GantSizeModel[],salePrice?:string) {
        this.name = name
        this.sizes = sizes
        this.salePrice = salePrice
    }
}

export class GantSizeModel {
    name: string;
    qty: string;
    price: string;

    constructor(name: string, qty: string, price: string) {
        this.name = name
        this.qty = qty
        this.price = price
    }
}